module.exports = __webpack_public_path__ + "img/Image.44708454.svg";